import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";

const state={
    listIndividus : [],
    listInscriptions : [],
    filtredListe:[],
    individu : {},
    listEcoles:[],
    listClasses:[],
    listInstits:[],
    listHisto:[],
    listAutorisations:[],
    listNiveau : [],
    listVille : [],
    filtrePrenom : false,
    currentAnneeScolaire : {},
    listEtablissementScolaireNiveau :[],
    listClasseScolaireNiveau : [],
    listClasseScolaireEnseignant : [],
    filtreIndividusJour : true,
    filtreAge : {
        actif : false, 
        value : {
            ageMin:0,
            ageMax:99
        }
    },
    filtreEcoles : {
        actif : false, 
        value : []
    },
    filtreClasses : {
        actif : false, 
        value : []
    },
    filtreNiveau : {
        actif : false, 
        value : []
    },
    filtreInstit : {
        actif : false, 
        value : []
    },
    filtreVille : {
        actif : false, 
        value : ''
    },
    filtrePointage : {
        actif : false, 
        value : ''
    },
    filtreGroupes : {
        actif : false, 
        value : []
    },
    filtreRegim : {
        actif : false, 
        value : []
    },
    
}
export default {
    namespaced : true,
    state,
    getters,
    actions,
    mutations
}